<template>
  <app-dropdown
      :options="mappedAlternatives"
      :value="motorId"
      @change="handleInput"
  ></app-dropdown>
</template>

<script>
import {mapGetters, mapState} from 'vuex';
import Dropdown from "../../input/Dropdown";

export default {
  name: 'MotorAlternativesDropdown',

  components: {
    'app-dropdown': Dropdown
  },

  computed: {
    ...mapState({
      motorId: state => state.build.motor,
      availableAlternatives: state => state.motors.availableAlternatives,
    }),

    mappedAlternatives() {
      return this.availableAlternatives
          .map(motor => {
            return {
              key: motor.id,
              value: motor.label ?? motor.title,
              recommended: motor.recommended,
            }
          });
    }
  },

  methods: {
    handleInput(id) {
      this.$store.dispatch('build/setMotor', id);
      this.$store.dispatch('motors/getMotorAlternatives')
    }
  },
  mounted() {
    this.$store.dispatch('motors/getMotorAlternatives')
  }
}
</script>
